// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/company_service.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CheckMaskImagesReadyRequestSchema, CheckMaskImagesReadyResponseSchema, CreateAiColorProjectRequestSchema, CreateAiColorProjectResponseSchema, CreateColorSimulationShareLinkRequestSchema, CreateColorSimulationShareLinkResponseSchema, DeleteColorSimulationImageRequestSchema, GetAiColorProjectRequestSchema, GetAiColorProjectResponseSchema, GetDealWithColorSimulationListResponseSchema, GetDealWithColorSimulationResponseSchema, LinkDealToAiColorProjectRequestSchema, LinkDealToAiColorProjectResponseSchema, ListAiColorProjectsRequestSchema, ListAiColorProjectsResponseSchema, ToggleColorSimulationImageFavoriteRequestSchema, ToggleColorSimulationImageFavoriteResponseSchema, UnlinkDealFromAiColorProjectRequestSchema, UnlinkDealFromAiColorProjectResponseSchema, UpdateAiColorProjectCustomerRequestSchema, UpdateAiColorProjectCustomerResponseSchema, UpdateAiColorProjectNameRequestSchema, UpdateAiColorProjectNameResponseSchema, UpdateColorSimulationImagePinRequestSchema, UpdateColorSimulationImagePinResponseSchema, UpdateColorSimulationImageTitleRequestSchema, UpdateColorSimulationImageTitleResponseSchema } from "./ai_color_simulation_pb";
import { file_api_proto_v1_ai_color_simulation } from "./ai_color_simulation_pb";
import type { GenerateSeoArticleRequestSchema, GenerateSeoArticleResponseSchema, GetSeoGenerationArticleRequestSchema, GetSeoGenerationArticleResponseSchema, ListSeoGenerationHistoryRequestSchema, ListSeoGenerationHistoryResponseSchema, ReviseSeoArticleRequestSchema } from "./ai_seo_writing_pb";
import { file_api_proto_v1_ai_seo_writing } from "./ai_seo_writing_pb";
import type { CalculateAreaEstimationDrawingAreaRequestSchema, CalculateAreaEstimationDrawingAreaResponseSchema, CreateAreaEstimationDrawingRequestSchema, CreateAreaEstimationDrawingResponseSchema, CreateAreaEstimationProjectRequestSchema, CreateAreaEstimationProjectResponseSchema, DeleteAreaEstimationDrawingRequestSchema, DeleteAreaEstimationProjectRequestSchema, GetAreaEstimationDrawingAnalysisStatusRequestSchema, GetAreaEstimationDrawingAnalysisStatusResponseSchema, GetAreaEstimationDrawingRequestSchema, GetAreaEstimationDrawingResponseSchema, GetAreaEstimationProjectRequestSchema, GetAreaEstimationProjectResponseSchema, ListAreaEstimationDrawingRevisionsRequestSchema, ListAreaEstimationDrawingRevisionsResponseSchema, ListAreaEstimationProjectsRequestSchema, ListAreaEstimationProjectsResponseSchema, ReanalyzeAreaEstimationDrawingRequestSchema, ReanalyzeAreaEstimationDrawingResponseSchema, SaveAreaEstimationDrawingGeometryRequestSchema, SaveAreaEstimationDrawingGeometryResponseSchema, UpdateAreaEstimationDrawingScaleRequestSchema, UpdateAreaEstimationDrawingScaleResponseSchema, UpdateAreaEstimationProjectRequestSchema, UpdateAreaEstimationProjectResponseSchema } from "./area_estimation_pb";
import { file_api_proto_v1_area_estimation } from "./area_estimation_pb";
import type { GetCaseStudyImagesRequestSchema, GetCaseStudyImagesResponseSchema, SaveCaseStudyImagesRequestSchema, SaveCaseStudyImagesResponseSchema } from "./case_study_pb";
import { file_api_proto_v1_case_study } from "./case_study_pb";
import type { CountNewColorsRequestSchema, CountNewColorsResponseSchema, CreateAiColorPresetRequestSchema, CreateAiColorPresetResponseSchema, DeleteAiColorPresetRequestSchema, DeleteAiColorPresetResponseSchema, GetBaseAreaPresetDefaultsRequestSchema, GetBaseAreaPresetDefaultsResponseSchema, ListAiColorPresetsRequestSchema, ListAiColorPresetsResponseSchema, ListCompanyColorsRequestSchema, ListCompanyColorsResponseSchema, SetBaseAreaPresetDefaultRequestSchema, SetBaseAreaPresetDefaultResponseSchema, UpdateAiColorPresetRequestSchema, UpdateAiColorPresetResponseSchema } from "./color_pb";
import { file_api_proto_v1_color } from "./color_pb";
import type { EmptyResponseSchema } from "./common_pb";
import { file_api_proto_v1_common } from "./common_pb";
import type { GetOwnCompanyDetailRequestSchema, GetOwnCompanyDetailResponseSchema, GetStaffsRequestSchema, GetStaffsResponseSchema, UpdateCompanyRequestSchema, UpdateCompanyResponseSchema } from "./company_pb";
import { file_api_proto_v1_company } from "./company_pb";
import type { CreateCustomerRequestSchema, DeleteCustomerRequestSchema, DeleteMultipleCustomerRequestSchema, GetCustomerFormGroupsResponseSchema, GetCustomerFormRequestSchema, GetCustomerListCSVResponseSchema, GetCustomerListRequestSchema, GetCustomerListResponseSchema, GetCustomerRequestSchema, GetCustomerResponseSchema, UpdateCustomerRequest, UpdateCustomerRequestSchema } from "./customer_pb";
import { file_api_proto_v1_customer } from "./customer_pb";
import type { CreateCustomerMemoRequestSchema, CustomerMemoResponseSchema, DeleteCustomerMemoRequestSchema, GetCustomerMemoListRequestSchema, GetCustomerMemoListResponseSchema, TogglePinCustomerMemoRequestSchema, UpdateCustomerMemoRequestSchema } from "./customer_memo_pb";
import { file_api_proto_v1_customer_memo } from "./customer_memo_pb";
import type { CreateAdditionalContractRequestSchema, CreateAdditionalContractResponseSchema, CreateDealForFeatureRequestSchema, CreateDealForFeatureResponseSchema, CreateDealRequest, CreateDealRequestSchema, CreateDealResponseSchema, CreateDealSavedSearchRequestSchema, CreateDealSavedSearchResponseSchema, CreateInvoiceFromDealRequestSchema, CreateInvoiceFromDealResponseSchema, CreateQuotationFromDealRequestSchema, CreateQuotationFromDealResponseSchema, DeleteAdditionalContractRequestSchema, DeleteAdditionalContractResponseSchema, DeleteDealRequestSchema, DeleteDealSavedSearchRequestSchema, DeleteDealSavedSearchResponseSchema, DeleteMultipleDealRequestSchema, GetAdditionalContractFormRequestSchema, GetAdditionalContractFormResponseSchema, GetConstructionContentOptionsRequestSchema, GetConstructionContentOptionsResponseSchema, GetDealDetailRequestSchema, GetDealDetailResponseSchema, GetDealFormGroupsResponseSchema, GetDealFormRequestSchema, GetDealFormsResponseSchema, GetDealListCSVResponseSchema, GetDealListRequestSchema, GetDealListResponseSchema, GetDealSavedSearchListRequestSchema, GetDealSavedSearchListResponseSchema, GetDealSavedSearchRequestSchema, GetDealSavedSearchResponseSchema, LinkInvoiceToDealRequestSchema, LinkInvoiceToDealResponseSchema, LinkQuotationToDealRequestSchema, LinkQuotationToDealResponseSchema, UpdateAdditionalContractRequestSchema, UpdateAdditionalContractResponseSchema, UpdateAllDealCustomerTypeRequestSchema, UpdateDealForFeatureRequestSchema, UpdateDealForFeatureResponseSchema, UpdateDealPartialRequestSchema, UpdateDealRequestSchema, UpdateDealResponseSchema, UpdateDealSavedSearchRequestSchema, UpdateDealSavedSearchResponseSchema, UpdateDealStatusRequestSchema, UpdateDealStatusResponseSchema } from "./deal_pb";
import { file_api_proto_v1_deal } from "./deal_pb";
import type { DeleteExternalDocumentRequestSchema, ExtractExternalDocumentRequestSchema, ExtractExternalDocumentResponseSchema, ImportExternalDocumentRequestSchema, ImportExternalDocumentResponseSchema } from "./deal_external_document_pb";
import { file_api_proto_v1_deal_external_document } from "./deal_external_document_pb";
import type { CreateDealFileUploadUrlRequestSchema, CreateDealFileUploadUrlResponseSchema, CreateDealFolderRequestSchema, CreateDealFolderResponseSchema, DeleteDealFilesRequestSchema, DeleteDealFolderRequestSchema, DownloadDealFilesAsZipRequestSchema, DownloadDealFilesAsZipResponseSchema, FinalizeDealFileUploadRequestSchema, FinalizeDealFileUploadResponseSchema, GetDealFileCountRequestSchema, GetDealFileCountResponseSchema, GetDealFilesRequestSchema, GetDealFilesResponseSchema, MoveDealFilesToFolderRequestSchema, MoveDealFilesToFolderResponseSchema, RenameDealFileRequestSchema, RenameDealFileResponseSchema, RenameDealFolderRequestSchema, RenameDealFolderResponseSchema, RotateDealFileImageRequestSchema, RotateDealFileImageResponseSchema, UploadDealFilesRequestSchema, UploadDealFilesResponseSchema } from "./deal_file_pb";
import { file_api_proto_v1_deal_file } from "./deal_file_pb";
import type { CreateDealMemoRequestSchema, DealMemoResponseSchema, DeleteDealMemoRequestSchema, GetDealMemoListRequestSchema, GetDealMemoListResponseSchema, TogglePinDealMemoRequestSchema, UpdateDealMemoRequestSchema } from "./deal_memo_pb";
import { file_api_proto_v1_deal_memo } from "./deal_memo_pb";
import type { Upload, UploadFileRequestSchema, UploadFileResponseSchema } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { CreateAndLinkDealToInvoiceRequestSchema, CreateInvoiceRequestSchema, CreateInvoiceResponseSchema, DeleteInvoiceRequestSchema, GenerateInvoiceNumberRequestSchema, GenerateInvoiceNumberResponseSchema, GetInvoiceListRequestSchema, GetInvoiceListResponseSchema, GetInvoiceRequestSchema, GetInvoiceResponseSchema, LinkDealToInvoiceRequestSchema, LinkDealToInvoiceResponseSchema, UnlinkDealFromInvoiceRequestSchema, UpdateInvoiceRequestSchema, UpdateInvoiceResponseSchema } from "./invoice_pb";
import { file_api_proto_v1_invoice } from "./invoice_pb";
import type { ListCompanyMaterialsRequestSchema, ListCompanyMaterialsResponseSchema } from "./material_pb";
import { file_api_proto_v1_material } from "./material_pb";
import type { GetMetabaseRequestSchema, GetMetabaseResponseSchema } from "./metabase_pb";
import { file_api_proto_v1_metabase } from "./metabase_pb";
import type { GetPendingNpsSurveyRequestSchema, GetPendingNpsSurveyResponseSchema, SubmitNpsResponseRequestSchema, SubmitNpsResponseResponseSchema } from "./nps_survey_pb";
import { file_api_proto_v1_nps_survey } from "./nps_survey_pb";
import type { RecognizeMemoImageRequestSchema, RecognizeMemoImageResponseSchema } from "./ocr_pb";
import { file_api_proto_v1_ocr } from "./ocr_pb";
import type { GetOwnPlanStatusRequestSchema, GetOwnPlanStatusResponseSchema, ListOwnCreditLedgerEntriesRequestSchema, ListOwnCreditLedgerEntriesResponseSchema, RecordFeatureBlockRequestSchema, RecordFeatureBlockResponseSchema, SubmitPlanInquiryRequestSchema, SubmitPlanInquiryResponseSchema } from "./plan_status_pb";
import { file_api_proto_v1_plan_status } from "./plan_status_pb";
import type { CreateAndLinkDealToQuotationRequestSchema, CreateQuotationRequestSchema, CreateQuotationResponseSchema, DeleteQuotationRequestSchema, GenerateQuotationNumberRequestSchema, GenerateQuotationNumberResponseSchema, GetQuotationListRequestSchema, GetQuotationListResponseSchema, GetQuotationRequestSchema, GetQuotationResponseSchema, LinkDealToQuotationRequestSchema, LinkDealToQuotationResponseSchema, UnlinkDealFromQuotationRequestSchema, UpdateQuotationRequestSchema, UpdateQuotationResponseSchema } from "./quotations_pb";
import { file_api_proto_v1_quotations } from "./quotations_pb";
import type { GetReviewQuestionConfigRequestSchema, GetReviewQuestionConfigResponseSchema, GetReviewSettingsRequestSchema, GetReviewSettingsResponseSchema, ListReviewSubmissionsRequestSchema, ListReviewSubmissionsResponseSchema, UpdateReviewQuestionConfigRequestSchema, UpdateReviewQuestionConfigResponseSchema, UpdateReviewSettingsRequestSchema, UpdateReviewSettingsResponseSchema } from "./review_generator_pb";
import { file_api_proto_v1_review_generator } from "./review_generator_pb";
import type { GetStaffAuthResponseSchema, GetStaffMeRequestSchema, LinkLineAccountRequestSchema, LinkLineAccountResponseSchema, LogoutRequestSchema, LogoutResponseSchema, SendLineTestMessageRequestSchema, SendLineTestMessageResponseSchema, StartLineLinkRequestSchema, StartLineLinkResponseSchema, UnlinkLineAccountRequestSchema, UnlinkLineAccountResponseSchema } from "./staff_pb";
import { file_api_proto_v1_staff } from "./staff_pb";
import type { DeleteSurveyReportRequestSchema, GenerateSurveyTextRequestSchema, GenerateSurveyTextResponseSchema, GetDealImagesRequestSchema, GetDealImagesResponseSchema, GetSurveyReportRequestSchema, GetSurveyReportResponseSchema, ListCompanySurveyReportsRequestSchema, ListCompanySurveyReportsResponseSchema, SaveSurveyReportRequestSchema, SaveSurveyReportResponseSchema } from "./survey_report_pb";
import { file_api_proto_v1_survey_report } from "./survey_report_pb";
import type { GetAddressRequestSchema, GetAddressResponseSchema, GetZipCodeRequestSchema } from "./zipcode_pb";
import { file_api_proto_v1_zipcode } from "./zipcode_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/company_service.proto.
 */
export const file_api_proto_v1_company_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_ai_color_simulation, file_api_proto_v1_ai_seo_writing, file_api_proto_v1_area_estimation, file_api_proto_v1_case_study, file_api_proto_v1_color, file_api_proto_v1_common, file_api_proto_v1_company, file_api_proto_v1_customer, file_api_proto_v1_customer_memo, file_api_proto_v1_deal, file_api_proto_v1_deal_external_document, file_api_proto_v1_deal_file, file_api_proto_v1_deal_memo, file_api_proto_v1_file, file_api_proto_v1_invoice, file_api_proto_v1_material, file_api_proto_v1_metabase, file_api_proto_v1_nps_survey, file_api_proto_v1_ocr, file_api_proto_v1_plan_status, file_api_proto_v1_quotations, file_api_proto_v1_review_generator, file_api_proto_v1_staff, file_api_proto_v1_survey_report, file_api_proto_v1_zipcode, file_google_protobuf_timestamp]);

/**
 * サーバーでgptからのレスポンスを受け取るために使用する
 *
 * @generated from message api_proto.v1.GptResponse
 */
export type GptResponse = Message<"api_proto.v1.GptResponse"> & {
  /**
   * @generated from field: api_proto.v1.CreateDealRequest deal = 1;
   */
  deal?: CreateDealRequest;

  /**
   * @generated from field: api_proto.v1.UpdateCustomerRequest customer = 2;
   */
  customer?: UpdateCustomerRequest;
};

/**
 * Describes the message api_proto.v1.GptResponse.
 * Use `create(GptResponseSchema)` to create a new message.
 */
export const GptResponseSchema: GenMessage<GptResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 0);

/**
 * 施工事例記事の自動作成リクエスト
 *
 * @generated from message api_proto.v1.GenerateCaseStudyRequest
 */
export type GenerateCaseStudyRequest = Message<"api_proto.v1.GenerateCaseStudyRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * 非推奨: work_supplementとwriting_instructionを使用
   *
   * @generated from field: string additional_prompt = 2 [deprecated = true];
   * @deprecated
   */
  additionalPrompt: string;

  /**
   * 工事内容についての補足説明（任意）
   *
   * @generated from field: string work_supplement = 3;
   */
  workSupplement: string;

  /**
   * 記事の書き方に対する追加指示（任意）
   *
   * @generated from field: string writing_instruction = 4;
   */
  writingInstruction: string;

  /**
   * リライトモードフラグ
   *
   * @generated from field: bool is_rewrite = 5;
   */
  isRewrite: boolean;

  /**
   * リライト対象の元記事（is_rewrite=trueの場合必須）
   *
   * @generated from field: string previous_content = 6;
   */
  previousContent: string;
};

/**
 * Describes the message api_proto.v1.GenerateCaseStudyRequest.
 * Use `create(GenerateCaseStudyRequestSchema)` to create a new message.
 */
export const GenerateCaseStudyRequestSchema: GenMessage<GenerateCaseStudyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 1);

/**
 * 施工事例記事の自動作成レスポンス
 *
 * @generated from message api_proto.v1.GenerateCaseStudyResponse
 */
export type GenerateCaseStudyResponse = Message<"api_proto.v1.GenerateCaseStudyResponse"> & {
  /**
   * @generated from field: api_proto.v1.CaseStudyArticle article = 1;
   */
  article?: CaseStudyArticle;

  /**
   * LLMからの生レスポンス（デバッグ用）
   *
   * @generated from field: string raw_response = 2;
   */
  rawResponse: string;
};

/**
 * Describes the message api_proto.v1.GenerateCaseStudyResponse.
 * Use `create(GenerateCaseStudyResponseSchema)` to create a new message.
 */
export const GenerateCaseStudyResponseSchema: GenMessage<GenerateCaseStudyResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 2);

/**
 * 施工事例記事データ
 *
 * @generated from message api_proto.v1.CaseStudyArticle
 */
export type CaseStudyArticle = Message<"api_proto.v1.CaseStudyArticle"> & {
  /**
   * 記事ID（DB保存後に設定される）
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: api_proto.v1.CaseStudyMetadata metadata = 2;
   */
  metadata?: CaseStudyMetadata;

  /**
   * 記事本文
   *
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * 工事内容の補足説明
   *
   * @generated from field: string work_supplement = 4;
   */
  workSupplement: string;

  /**
   * 記事の書き方指示
   *
   * @generated from field: string writing_instruction = 5;
   */
  writingInstruction: string;

  /**
   * 生成回数
   *
   * @generated from field: int32 generation_count = 6;
   */
  generationCount: number;

  /**
   * 作成日時
   *
   * @generated from field: google.protobuf.Timestamp created = 7;
   */
  created?: Timestamp;

  /**
   * 記事ステータス
   *
   * @generated from field: api_proto.v1.CaseStudyArticleStatus status = 8;
   */
  status: CaseStudyArticleStatus;

  /**
   * 施主許諾
   *
   * @generated from field: bool owner_consent = 9;
   */
  ownerConsent: boolean;
};

/**
 * Describes the message api_proto.v1.CaseStudyArticle.
 * Use `create(CaseStudyArticleSchema)` to create a new message.
 */
export const CaseStudyArticleSchema: GenMessage<CaseStudyArticle> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 3);

/**
 * 案件選択 Drawer 用：案件 + 記事メタの一覧アイテム
 *
 * @generated from message api_proto.v1.CaseStudyDealListItem
 */
export type CaseStudyDealListItem = Message<"api_proto.v1.CaseStudyDealListItem"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: string deal_name = 2;
   */
  dealName: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * 案件ステータス（DealStatus の表記）
   *
   * @generated from field: string deal_status = 4;
   */
  dealStatus: string;

  /**
   * 完工日（存在する場合）
   *
   * @generated from field: google.protobuf.Timestamp completion_date = 5;
   */
  completionDate?: Timestamp;

  /**
   * 記事ステータス（記事行が無ければ UNPROCESSED）
   *
   * @generated from field: api_proto.v1.CaseStudyArticleStatus article_status = 6;
   */
  articleStatus: CaseStudyArticleStatus;

  /**
   * 施主許諾
   *
   * @generated from field: bool owner_consent = 7;
   */
  ownerConsent: boolean;

  /**
   * 情報不足（記事生成に必要な項目が欠けている）
   *
   * @generated from field: bool has_insufficient_info = 8;
   */
  hasInsufficientInfo: boolean;

  /**
   * 最新記事の ID（存在する場合）
   *
   * @generated from field: optional int64 article_id = 9;
   */
  articleId?: bigint;
};

/**
 * Describes the message api_proto.v1.CaseStudyDealListItem.
 * Use `create(CaseStudyDealListItemSchema)` to create a new message.
 */
export const CaseStudyDealListItemSchema: GenMessage<CaseStudyDealListItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 4);

/**
 * @generated from message api_proto.v1.ListCaseStudyDealsRequest
 */
export type ListCaseStudyDealsRequest = Message<"api_proto.v1.ListCaseStudyDealsRequest"> & {
  /**
   * フリーワード検索
   *
   * @generated from field: string keyword = 1;
   */
  keyword: string;

  /**
   * 完工案件のみ
   *
   * @generated from field: bool only_completed = 2;
   */
  onlyCompleted: boolean;

  /**
   * 1 始まり
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 4;
   */
  perPage: number;

  /**
   * @generated from field: api_proto.v1.CaseStudyDealSortKey sort_key = 5;
   */
  sortKey: CaseStudyDealSortKey;

  /**
   * @generated from field: api_proto.v1.CaseStudySortOrder sort_order = 6;
   */
  sortOrder: CaseStudySortOrder;
};

/**
 * Describes the message api_proto.v1.ListCaseStudyDealsRequest.
 * Use `create(ListCaseStudyDealsRequestSchema)` to create a new message.
 */
export const ListCaseStudyDealsRequestSchema: GenMessage<ListCaseStudyDealsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 5);

/**
 * @generated from message api_proto.v1.ListCaseStudyDealsResponse
 */
export type ListCaseStudyDealsResponse = Message<"api_proto.v1.ListCaseStudyDealsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CaseStudyDealListItem items = 1;
   */
  items: CaseStudyDealListItem[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message api_proto.v1.ListCaseStudyDealsResponse.
 * Use `create(ListCaseStudyDealsResponseSchema)` to create a new message.
 */
export const ListCaseStudyDealsResponseSchema: GenMessage<ListCaseStudyDealsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 6);

/**
 * @generated from message api_proto.v1.UpdateCaseStudyArticleStatusRequest
 */
export type UpdateCaseStudyArticleStatusRequest = Message<"api_proto.v1.UpdateCaseStudyArticleStatusRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: api_proto.v1.CaseStudyArticleStatus status = 2;
   */
  status: CaseStudyArticleStatus;
};

/**
 * Describes the message api_proto.v1.UpdateCaseStudyArticleStatusRequest.
 * Use `create(UpdateCaseStudyArticleStatusRequestSchema)` to create a new message.
 */
export const UpdateCaseStudyArticleStatusRequestSchema: GenMessage<UpdateCaseStudyArticleStatusRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 7);

/**
 * @generated from message api_proto.v1.UpdateCaseStudyArticleStatusResponse
 */
export type UpdateCaseStudyArticleStatusResponse = Message<"api_proto.v1.UpdateCaseStudyArticleStatusResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateCaseStudyArticleStatusResponse.
 * Use `create(UpdateCaseStudyArticleStatusResponseSchema)` to create a new message.
 */
export const UpdateCaseStudyArticleStatusResponseSchema: GenMessage<UpdateCaseStudyArticleStatusResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 8);

/**
 * @generated from message api_proto.v1.UpdateCaseStudyOwnerConsentRequest
 */
export type UpdateCaseStudyOwnerConsentRequest = Message<"api_proto.v1.UpdateCaseStudyOwnerConsentRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: bool owner_consent = 2;
   */
  ownerConsent: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateCaseStudyOwnerConsentRequest.
 * Use `create(UpdateCaseStudyOwnerConsentRequestSchema)` to create a new message.
 */
export const UpdateCaseStudyOwnerConsentRequestSchema: GenMessage<UpdateCaseStudyOwnerConsentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 9);

/**
 * @generated from message api_proto.v1.UpdateCaseStudyOwnerConsentResponse
 */
export type UpdateCaseStudyOwnerConsentResponse = Message<"api_proto.v1.UpdateCaseStudyOwnerConsentResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateCaseStudyOwnerConsentResponse.
 * Use `create(UpdateCaseStudyOwnerConsentResponseSchema)` to create a new message.
 */
export const UpdateCaseStudyOwnerConsentResponseSchema: GenMessage<UpdateCaseStudyOwnerConsentResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 10);

/**
 * 施工事例記事メタデータ
 *
 * @generated from message api_proto.v1.CaseStudyMetadata
 */
export type CaseStudyMetadata = Message<"api_proto.v1.CaseStudyMetadata"> & {
  /**
   * タイトル
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * 説明
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * URL用スラッグ
   *
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * 地域
   *
   * @generated from field: string area = 4;
   */
  area: string;

  /**
   * 施工箇所
   *
   * @generated from field: string section = 5;
   */
  section: string;

  /**
   * 工事種別
   *
   * @generated from field: string work_type = 6;
   */
  workType: string;

  /**
   * 工期
   *
   * @generated from field: string duration = 7;
   */
  duration: string;

  /**
   * 費用
   *
   * @generated from field: string cost = 8;
   */
  cost: string;

  /**
   * 築年数
   *
   * @generated from field: string age = 9;
   */
  age: string;
};

/**
 * Describes the message api_proto.v1.CaseStudyMetadata.
 * Use `create(CaseStudyMetadataSchema)` to create a new message.
 */
export const CaseStudyMetadataSchema: GenMessage<CaseStudyMetadata> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 11);

/**
 * 案件IDで最新の施工事例記事を取得するリクエスト
 *
 * @generated from message api_proto.v1.GetCaseStudyArticlesByDealIdRequest
 */
export type GetCaseStudyArticlesByDealIdRequest = Message<"api_proto.v1.GetCaseStudyArticlesByDealIdRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetCaseStudyArticlesByDealIdRequest.
 * Use `create(GetCaseStudyArticlesByDealIdRequestSchema)` to create a new message.
 */
export const GetCaseStudyArticlesByDealIdRequestSchema: GenMessage<GetCaseStudyArticlesByDealIdRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 12);

/**
 * 案件単位の施工事例メタ（記事ステータス・施主許諾）
 *
 * @generated from message api_proto.v1.CaseStudyDealMeta
 */
export type CaseStudyDealMeta = Message<"api_proto.v1.CaseStudyDealMeta"> & {
  /**
   * 記事ステータス（NULL→UNPROCESSED）
   *
   * @generated from field: api_proto.v1.CaseStudyArticleStatus status = 1;
   */
  status: CaseStudyArticleStatus;

  /**
   * @generated from field: bool owner_consent = 2;
   */
  ownerConsent: boolean;
};

/**
 * Describes the message api_proto.v1.CaseStudyDealMeta.
 * Use `create(CaseStudyDealMetaSchema)` to create a new message.
 */
export const CaseStudyDealMetaSchema: GenMessage<CaseStudyDealMeta> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 13);

/**
 * 案件IDで最新の施工事例記事を取得するレスポンス
 *
 * @generated from message api_proto.v1.GetCaseStudyArticlesByDealIdResponse
 */
export type GetCaseStudyArticlesByDealIdResponse = Message<"api_proto.v1.GetCaseStudyArticlesByDealIdResponse"> & {
  /**
   * 最新の記事（存在しない場合はnil）
   *
   * @generated from field: api_proto.v1.CaseStudyArticle article = 1;
   */
  article?: CaseStudyArticle;

  /**
   * バリデーション情報（記事が存在しない場合のみ設定）
   *
   * 記事生成可能かどうか
   *
   * @generated from field: bool can_generate = 2;
   */
  canGenerate: boolean;

  /**
   * 不足している必須フィールド
   *
   * @generated from field: repeated string missing_fields = 3;
   */
  missingFields: string[];

  /**
   * 案件単位の状態（記事行が無くても返す）
   *
   * @generated from field: api_proto.v1.CaseStudyDealMeta meta = 4;
   */
  meta?: CaseStudyDealMeta;
};

/**
 * Describes the message api_proto.v1.GetCaseStudyArticlesByDealIdResponse.
 * Use `create(GetCaseStudyArticlesByDealIdResponseSchema)` to create a new message.
 */
export const GetCaseStudyArticlesByDealIdResponseSchema: GenMessage<GetCaseStudyArticlesByDealIdResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 14);

/**
 * @generated from message api_proto.v1.UploadCsvRequest
 */
export type UploadCsvRequest = Message<"api_proto.v1.UploadCsvRequest"> & {
  /**
   * @generated from field: api_proto.v1.Upload file = 1;
   */
  file?: Upload;
};

/**
 * Describes the message api_proto.v1.UploadCsvRequest.
 * Use `create(UploadCsvRequestSchema)` to create a new message.
 */
export const UploadCsvRequestSchema: GenMessage<UploadCsvRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 15);

/**
 * AIカラーシミュレーションサービスのPre-warming用メッセージ
 *
 * @generated from message api_proto.v1.WarmUpAIColorServiceRequest
 */
export type WarmUpAIColorServiceRequest = Message<"api_proto.v1.WarmUpAIColorServiceRequest"> & {
};

/**
 * Describes the message api_proto.v1.WarmUpAIColorServiceRequest.
 * Use `create(WarmUpAIColorServiceRequestSchema)` to create a new message.
 */
export const WarmUpAIColorServiceRequestSchema: GenMessage<WarmUpAIColorServiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 16);

/**
 * @generated from message api_proto.v1.WarmUpAIColorServiceResponse
 */
export type WarmUpAIColorServiceResponse = Message<"api_proto.v1.WarmUpAIColorServiceResponse"> & {
  /**
   * "ready"
   *
   * @generated from field: string status = 1;
   */
  status: string;
};

/**
 * Describes the message api_proto.v1.WarmUpAIColorServiceResponse.
 * Use `create(WarmUpAIColorServiceResponseSchema)` to create a new message.
 */
export const WarmUpAIColorServiceResponseSchema: GenMessage<WarmUpAIColorServiceResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_service, 17);

/**
 * 施工事例記事ステータス
 *
 * @generated from enum api_proto.v1.CaseStudyArticleStatus
 */
export enum CaseStudyArticleStatus {
  /**
   * @generated from enum value: CASE_STUDY_ARTICLE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未対応（記事未生成）
   *
   * @generated from enum value: CASE_STUDY_ARTICLE_STATUS_UNPROCESSED = 1;
   */
  UNPROCESSED = 1,

  /**
   * 下書き
   *
   * @generated from enum value: CASE_STUDY_ARTICLE_STATUS_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * 公開中
   *
   * @generated from enum value: CASE_STUDY_ARTICLE_STATUS_PUBLISHED = 3;
   */
  PUBLISHED = 3,
}

/**
 * Describes the enum api_proto.v1.CaseStudyArticleStatus.
 */
export const CaseStudyArticleStatusSchema: GenEnum<CaseStudyArticleStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_company_service, 0);

/**
 * 一覧の並び替え（Figma で「案件ステータス」「完工日」がソート可能）
 *
 * @generated from enum api_proto.v1.CaseStudyDealSortKey
 */
export enum CaseStudyDealSortKey {
  /**
   * @generated from enum value: CASE_STUDY_DEAL_SORT_KEY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CASE_STUDY_DEAL_SORT_KEY_DEAL_STATUS = 1;
   */
  DEAL_STATUS = 1,

  /**
   * @generated from enum value: CASE_STUDY_DEAL_SORT_KEY_COMPLETION_DATE = 2;
   */
  COMPLETION_DATE = 2,
}

/**
 * Describes the enum api_proto.v1.CaseStudyDealSortKey.
 */
export const CaseStudyDealSortKeySchema: GenEnum<CaseStudyDealSortKey> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_company_service, 1);

/**
 * @generated from enum api_proto.v1.CaseStudySortOrder
 */
export enum CaseStudySortOrder {
  /**
   * @generated from enum value: CASE_STUDY_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CASE_STUDY_SORT_ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: CASE_STUDY_SORT_ORDER_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum api_proto.v1.CaseStudySortOrder.
 */
export const CaseStudySortOrderSchema: GenEnum<CaseStudySortOrder> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_company_service, 2);

/**
 * @generated from service api_proto.v1.CompanyService
 */
export const CompanyService: GenService<{
  /**
   * 自社の企業情報を更新する
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateCompany
   */
  updateCompany: {
    methodKind: "unary";
    input: typeof UpdateCompanyRequestSchema;
    output: typeof UpdateCompanyResponseSchema;
  },
  /**
   * 自社情報を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetOwnCompanyDetail
   */
  getOwnCompanyDetail: {
    methodKind: "unary";
    input: typeof GetOwnCompanyDetailRequestSchema;
    output: typeof GetOwnCompanyDetailResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetStaffMe
   */
  getStaffMe: {
    methodKind: "unary";
    input: typeof GetStaffMeRequestSchema;
    output: typeof GetStaffAuthResponseSchema;
  },
  /**
   * ログアウト（サーバー側でFirebaseのrefresh tokenを失効させる）
   *
   * @generated from rpc api_proto.v1.CompanyService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetStaffs
   */
  getStaffs: {
    methodKind: "unary";
    input: typeof GetStaffsRequestSchema;
    output: typeof GetStaffsResponseSchema;
  },
  /**
   * LINE 連携フローを開始する。
   * サーバが state を発番・セッション保存し、LINE 認可 URL を返す。
   *
   * @generated from rpc api_proto.v1.CompanyService.StartLineLink
   */
  startLineLink: {
    methodKind: "unary";
    input: typeof StartLineLinkRequestSchema;
    output: typeof StartLineLinkResponseSchema;
  },
  /**
   * LINE 認可コールバックで受け取った code/state を交換し、LINE userId を現在のスタッフに紐付ける。
   *
   * @generated from rpc api_proto.v1.CompanyService.LinkLineAccount
   */
  linkLineAccount: {
    methodKind: "unary";
    input: typeof LinkLineAccountRequestSchema;
    output: typeof LinkLineAccountResponseSchema;
  },
  /**
   * 現在のスタッフの LINE 連携を解除する（line_id をクリア）。
   *
   * @generated from rpc api_proto.v1.CompanyService.UnlinkLineAccount
   */
  unlinkLineAccount: {
    methodKind: "unary";
    input: typeof UnlinkLineAccountRequestSchema;
    output: typeof UnlinkLineAccountResponseSchema;
  },
  /**
   * LINE自然文案件操作のテスト送信。準備状態（GetStaffMeのline_readiness）がreadyのときだけ、
   * AIチャットボット用公式アカウントから使い方の1通をpushする。1日3回まで。
   *
   * @generated from rpc api_proto.v1.CompanyService.SendLineTestMessage
   */
  sendLineTestMessage: {
    methodKind: "unary";
    input: typeof SendLineTestMessageRequestSchema;
    output: typeof SendLineTestMessageResponseSchema;
  },
  /**
   * deal
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealFormSimple
   */
  getDealFormSimple: {
    methodKind: "unary";
    input: typeof GetDealFormRequestSchema;
    output: typeof GetDealFormsResponseSchema;
  },
  /**
   * 一覧表示用
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealFormForList
   */
  getDealFormForList: {
    methodKind: "unary";
    input: typeof GetDealFormRequestSchema;
    output: typeof GetDealFormsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealForm
   */
  getDealForm: {
    methodKind: "unary";
    input: typeof GetDealFormRequestSchema;
    output: typeof GetDealFormGroupsResponseSchema;
  },
  /**
   * 追加契約フォーム取得
   *
   * @generated from rpc api_proto.v1.CompanyService.GetAdditionalContractForm
   */
  getAdditionalContractForm: {
    methodKind: "unary";
    input: typeof GetAdditionalContractFormRequestSchema;
    output: typeof GetAdditionalContractFormResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.CreateDealSimple
   */
  createDealSimple: {
    methodKind: "unary";
    input: typeof CreateDealRequestSchema;
    output: typeof CreateDealResponseSchema;
  },
  /**
   * 案件必須系機能（現地調査報告書・施工事例記事）の中から案件を作る（決定 63）。
   * 権限は crm.deals ではなく feature_permission_code の機能権限（full）で判定する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateDealForFeature
   */
  createDealForFeature: {
    methodKind: "unary";
    input: typeof CreateDealForFeatureRequestSchema;
    output: typeof CreateDealForFeatureResponseSchema;
  },
  /**
   * 案件必須系機能の画面から案件名・顧客名を直す（資格は feature_permission_code の機能の full。message のコメント参照）
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateDealForFeature
   */
  updateDealForFeature: {
    methodKind: "unary";
    input: typeof UpdateDealForFeatureRequestSchema;
    output: typeof UpdateDealForFeatureResponseSchema;
  },
  /**
   * メモ写真の文字起こし (issue #2222)。R2 保存を伴うため NO_SIDE_EFFECTS なし。
   * 利用には COMPANY_PERMISSION_TYPE_CRM が必要
   *
   * @generated from rpc api_proto.v1.CompanyService.RecognizeMemoImage
   */
  recognizeMemoImage: {
    methodKind: "unary";
    input: typeof RecognizeMemoImageRequestSchema;
    output: typeof RecognizeMemoImageResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.CreateDeal
   */
  createDeal: {
    methodKind: "unary";
    input: typeof CreateDealRequestSchema;
    output: typeof CreateDealResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateDeal
   */
  updateDeal: {
    methodKind: "unary";
    input: typeof UpdateDealRequestSchema;
    output: typeof UpdateDealResponseSchema;
  },
  /**
   * UpdateDealとスキーマは一緒だが、UpdateDealPartialは一部のみ更新するためのもの
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateDealPatch
   */
  updateDealPatch: {
    methodKind: "unary";
    input: typeof UpdateDealRequestSchema;
    output: typeof UpdateDealResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateDealPartial
   */
  updateDealPartial: {
    methodKind: "unary";
    input: typeof UpdateDealPartialRequestSchema;
    output: typeof UpdateDealResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealList
   */
  getDealList: {
    methodKind: "unary";
    input: typeof GetDealListRequestSchema;
    output: typeof GetDealListResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealListCSV
   */
  getDealListCSV: {
    methodKind: "unary";
    input: typeof GetDealListRequestSchema;
    output: typeof GetDealListCSVResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealDetail
   */
  getDealDetail: {
    methodKind: "unary";
    input: typeof GetDealDetailRequestSchema;
    output: typeof GetDealDetailResponseSchema;
  },
  /**
   * AIカラーシュミレーションを行った案件の詳細を取得
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealWithColorSimulation
   */
  getDealWithColorSimulation: {
    methodKind: "unary";
    input: typeof GetDealDetailRequestSchema;
    output: typeof GetDealWithColorSimulationResponseSchema;
  },
  /**
   * AIカラーシュミレーションを行った案件一覧を取得
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealWithColorSimulationList
   */
  getDealWithColorSimulationList: {
    methodKind: "unary";
    input: typeof GetDealListRequestSchema;
    output: typeof GetDealWithColorSimulationListResponseSchema;
  },
  /**
   * AIカラーシミュレーションサービスのPre-warming
   *
   * @generated from rpc api_proto.v1.CompanyService.WarmUpAIColorService
   */
  warmUpAIColorService: {
    methodKind: "unary";
    input: typeof WarmUpAIColorServiceRequestSchema;
    output: typeof WarmUpAIColorServiceResponseSchema;
  },
  /**
   * マスク画像生成完了チェック（ポーリング用）
   *
   * @generated from rpc api_proto.v1.CompanyService.CheckMaskImagesReady
   */
  checkMaskImagesReady: {
    methodKind: "unary";
    input: typeof CheckMaskImagesReadyRequestSchema;
    output: typeof CheckMaskImagesReadyResponseSchema;
  },
  /**
   * AIカラー画像のお気に入り更新
   *
   * @generated from rpc api_proto.v1.CompanyService.ToggleColorSimulationImageFavorite
   */
  toggleColorSimulationImageFavorite: {
    methodKind: "unary";
    input: typeof ToggleColorSimulationImageFavoriteRequestSchema;
    output: typeof ToggleColorSimulationImageFavoriteResponseSchema;
  },
  /**
   * AIカラーのシミュレーション結果画像を削除
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteColorSimulationImage
   */
  deleteColorSimulationImage: {
    methodKind: "unary";
    input: typeof DeleteColorSimulationImageRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * AIカラー履歴のタイトル更新（issue #2370）
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateColorSimulationImageTitle
   */
  updateColorSimulationImageTitle: {
    methodKind: "unary";
    input: typeof UpdateColorSimulationImageTitleRequestSchema;
    output: typeof UpdateColorSimulationImageTitleResponseSchema;
  },
  /**
   * AIカラー履歴のピン留め設定・解除（issue #2953。1プロジェクト4件まで）
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateColorSimulationImagePin
   */
  updateColorSimulationImagePin: {
    methodKind: "unary";
    input: typeof UpdateColorSimulationImagePinRequestSchema;
    output: typeof UpdateColorSimulationImagePinResponseSchema;
  },
  /**
   * AIカラー共有リンクを作成
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateColorSimulationShareLink
   */
  createColorSimulationShareLink: {
    methodKind: "unary";
    input: typeof CreateColorSimulationShareLinkRequestSchema;
    output: typeof CreateColorSimulationShareLinkResponseSchema;
  },
  /**
   * AIカラープロジェクトを作成（deal非依存。issue #1828）
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAiColorProject
   */
  createAiColorProject: {
    methodKind: "unary";
    input: typeof CreateAiColorProjectRequestSchema;
    output: typeof CreateAiColorProjectResponseSchema;
  },
  /**
   * AIカラープロジェクト（deal非依存）の詳細＋画像一覧を取得
   *
   * @generated from rpc api_proto.v1.CompanyService.GetAiColorProject
   */
  getAiColorProject: {
    methodKind: "unary";
    input: typeof GetAiColorProjectRequestSchema;
    output: typeof GetAiColorProjectResponseSchema;
  },
  /**
   * AIカラープロジェクト名を更新
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateAiColorProjectName
   */
  updateAiColorProjectName: {
    methodKind: "unary";
    input: typeof UpdateAiColorProjectNameRequestSchema;
    output: typeof UpdateAiColorProjectNameResponseSchema;
  },
  /**
   * AIカラープロジェクトの顧客を変更/アサイン（案件連携の前提。要 CRM 権限）
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateAiColorProjectCustomer
   */
  updateAiColorProjectCustomer: {
    methodKind: "unary";
    input: typeof UpdateAiColorProjectCustomerRequestSchema;
    output: typeof UpdateAiColorProjectCustomerResponseSchema;
  },
  /**
   * AIカラープロジェクト一覧を取得（deal非依存の正式な一覧。issue #1828 follow-up）
   *
   * @generated from rpc api_proto.v1.CompanyService.ListAiColorProjects
   */
  listAiColorProjects: {
    methodKind: "unary";
    input: typeof ListAiColorProjectsRequestSchema;
    output: typeof ListAiColorProjectsResponseSchema;
  },
  /**
   * 案件を AIカラープロジェクトに連携
   *
   * @generated from rpc api_proto.v1.CompanyService.LinkDealToAiColorProject
   */
  linkDealToAiColorProject: {
    methodKind: "unary";
    input: typeof LinkDealToAiColorProjectRequestSchema;
    output: typeof LinkDealToAiColorProjectResponseSchema;
  },
  /**
   * AIカラープロジェクトから案件連携を解除
   *
   * @generated from rpc api_proto.v1.CompanyService.UnlinkDealFromAiColorProject
   */
  unlinkDealFromAiColorProject: {
    methodKind: "unary";
    input: typeof UnlinkDealFromAiColorProjectRequestSchema;
    output: typeof UnlinkDealFromAiColorProjectResponseSchema;
  },
  /**
   * 案件情報更新
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateDealStatus
   */
  updateDealStatus: {
    methodKind: "unary";
    input: typeof UpdateDealStatusRequestSchema;
    output: typeof UpdateDealStatusResponseSchema;
  },
  /**
   * 追加工事契約
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAdditionalContract
   */
  createAdditionalContract: {
    methodKind: "unary";
    input: typeof CreateAdditionalContractRequestSchema;
    output: typeof CreateAdditionalContractResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateAdditionalContract
   */
  updateAdditionalContract: {
    methodKind: "unary";
    input: typeof UpdateAdditionalContractRequestSchema;
    output: typeof UpdateAdditionalContractResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteAdditionalContract
   */
  deleteAdditionalContract: {
    methodKind: "unary";
    input: typeof DeleteAdditionalContractRequestSchema;
    output: typeof DeleteAdditionalContractResponseSchema;
  },
  /**
   * 削除
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteDeal
   */
  deleteDeal: {
    methodKind: "unary";
    input: typeof DeleteDealRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteMultipleDeal
   */
  deleteMultipleDeal: {
    methodKind: "unary";
    input: typeof DeleteMultipleDealRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 顧客リストを取得
   *
   * @generated from rpc api_proto.v1.CompanyService.GetCustomerList
   */
  getCustomerList: {
    methodKind: "unary";
    input: typeof GetCustomerListRequestSchema;
    output: typeof GetCustomerListResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetCustomerListCSV
   */
  getCustomerListCSV: {
    methodKind: "unary";
    input: typeof GetCustomerListRequestSchema;
    output: typeof GetCustomerListCSVResponseSchema;
  },
  /**
   * 顧客を作成する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateCustomer
   */
  createCustomer: {
    methodKind: "unary";
    input: typeof CreateCustomerRequestSchema;
    output: typeof GetCustomerResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateCustomer
   */
  updateCustomer: {
    methodKind: "unary";
    input: typeof UpdateCustomerRequestSchema;
    output: typeof GetCustomerResponseSchema;
  },
  /**
   * 顧客を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetCustomer
   */
  getCustomer: {
    methodKind: "unary";
    input: typeof GetCustomerRequestSchema;
    output: typeof GetCustomerResponseSchema;
  },
  /**
   * 顧客作成フォームリストを取得
   *
   * @generated from rpc api_proto.v1.CompanyService.GetCustomerForm
   */
  getCustomerForm: {
    methodKind: "unary";
    input: typeof GetCustomerFormRequestSchema;
    output: typeof GetCustomerFormGroupsResponseSchema;
  },
  /**
   * 顧客を削除する
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteCustomer
   */
  deleteCustomer: {
    methodKind: "unary";
    input: typeof DeleteCustomerRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteMultipleCustomer
   */
  deleteMultipleCustomer: {
    methodKind: "unary";
    input: typeof DeleteMultipleCustomerRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 指定顧客のすべての案件の顧客種別を更新する
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateAllDealCustomerType
   */
  updateAllDealCustomerType: {
    methodKind: "unary";
    input: typeof UpdateAllDealCustomerTypeRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * その他
   *
   * @generated from rpc api_proto.v1.CompanyService.UploadFile
   */
  uploadFile: {
    methodKind: "unary";
    input: typeof UploadFileRequestSchema;
    output: typeof UploadFileResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetAddress
   */
  getAddress: {
    methodKind: "unary";
    input: typeof GetAddressRequestSchema;
    output: typeof GetAddressResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetZipCode
   */
  getZipCode: {
    methodKind: "unary";
    input: typeof GetZipCodeRequestSchema;
    output: typeof GetAddressResponseSchema;
  },
  /**
   * 案件ファイル管理
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealFileCount
   */
  getDealFileCount: {
    methodKind: "unary";
    input: typeof GetDealFileCountRequestSchema;
    output: typeof GetDealFileCountResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealFiles
   */
  getDealFiles: {
    methodKind: "unary";
    input: typeof GetDealFilesRequestSchema;
    output: typeof GetDealFilesResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UploadDealFiles
   */
  uploadDealFiles: {
    methodKind: "unary";
    input: typeof UploadDealFilesRequestSchema;
    output: typeof UploadDealFilesResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.CreateDealFolder
   */
  createDealFolder: {
    methodKind: "unary";
    input: typeof CreateDealFolderRequestSchema;
    output: typeof CreateDealFolderResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.RenameDealFolder
   */
  renameDealFolder: {
    methodKind: "unary";
    input: typeof RenameDealFolderRequestSchema;
    output: typeof RenameDealFolderResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.MoveDealFilesToFolder
   */
  moveDealFilesToFolder: {
    methodKind: "unary";
    input: typeof MoveDealFilesToFolderRequestSchema;
    output: typeof MoveDealFilesToFolderResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.RenameDealFile
   */
  renameDealFile: {
    methodKind: "unary";
    input: typeof RenameDealFileRequestSchema;
    output: typeof RenameDealFileResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteDealFolder
   */
  deleteDealFolder: {
    methodKind: "unary";
    input: typeof DeleteDealFolderRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteDealFiles
   */
  deleteDealFiles: {
    methodKind: "unary";
    input: typeof DeleteDealFilesRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.CreateDealFileUploadUrl
   */
  createDealFileUploadUrl: {
    methodKind: "unary";
    input: typeof CreateDealFileUploadUrlRequestSchema;
    output: typeof CreateDealFileUploadUrlResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.FinalizeDealFileUpload
   */
  finalizeDealFileUpload: {
    methodKind: "unary";
    input: typeof FinalizeDealFileUploadRequestSchema;
    output: typeof FinalizeDealFileUploadResponseSchema;
  },
  /**
   * 案件ファイル画像の回転 (issue #2599)。画像の実体を回転して差し替えるため、
   * その写真を参照する報告書・施工事例は作成時期を問わず回転後の向きになる。
   *
   * @generated from rpc api_proto.v1.CompanyService.RotateDealFileImage
   */
  rotateDealFileImage: {
    methodKind: "unary";
    input: typeof RotateDealFileImageRequestSchema;
    output: typeof RotateDealFileImageResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DownloadDealFilesAsZip
   */
  downloadDealFilesAsZip: {
    methodKind: "server_streaming";
    input: typeof DownloadDealFilesAsZipRequestSchema;
    output: typeof DownloadDealFilesAsZipResponseSchema;
  },
  /**
   * 外部で作成した見積書・請求書 PDF の取り込み (issue #2404)
   * 権限は見積書が paperwork.quotations、請求書が paperwork.invoices。
   * 読み取り (Extract) は何も保存しない。確認画面で確定したときに Import で保存・反映する。
   *
   * @generated from rpc api_proto.v1.CompanyService.ExtractExternalDocument
   */
  extractExternalDocument: {
    methodKind: "unary";
    input: typeof ExtractExternalDocumentRequestSchema;
    output: typeof ExtractExternalDocumentResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.ImportExternalDocument
   */
  importExternalDocument: {
    methodKind: "unary";
    input: typeof ImportExternalDocumentRequestSchema;
    output: typeof ImportExternalDocumentResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteExternalDocument
   */
  deleteExternalDocument: {
    methodKind: "unary";
    input: typeof DeleteExternalDocumentRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * Metabase情報を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetMetabase
   */
  getMetabase: {
    methodKind: "unary";
    input: typeof GetMetabaseRequestSchema;
    output: typeof GetMetabaseResponseSchema;
  },
  /**
   * 案件対応メモを作成する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateDealMemo
   */
  createDealMemo: {
    methodKind: "unary";
    input: typeof CreateDealMemoRequestSchema;
    output: typeof DealMemoResponseSchema;
  },
  /**
   * 案件対応メモを更新する
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateDealMemo
   */
  updateDealMemo: {
    methodKind: "unary";
    input: typeof UpdateDealMemoRequestSchema;
    output: typeof DealMemoResponseSchema;
  },
  /**
   * 案件対応メモを削除する
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteDealMemo
   */
  deleteDealMemo: {
    methodKind: "unary";
    input: typeof DeleteDealMemoRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 案件対応メモ一覧を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealMemoList
   */
  getDealMemoList: {
    methodKind: "unary";
    input: typeof GetDealMemoListRequestSchema;
    output: typeof GetDealMemoListResponseSchema;
  },
  /**
   * 案件対応メモのピン留め切り替え
   *
   * @generated from rpc api_proto.v1.CompanyService.TogglePinDealMemo
   */
  togglePinDealMemo: {
    methodKind: "unary";
    input: typeof TogglePinDealMemoRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UploadCustomerCsv
   */
  uploadCustomerCsv: {
    methodKind: "unary";
    input: typeof UploadCsvRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UploadDealCsv
   */
  uploadDealCsv: {
    methodKind: "unary";
    input: typeof UploadCsvRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 案件保存検索
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateDealSavedSearch
   */
  createDealSavedSearch: {
    methodKind: "unary";
    input: typeof CreateDealSavedSearchRequestSchema;
    output: typeof CreateDealSavedSearchResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealSavedSearchList
   */
  getDealSavedSearchList: {
    methodKind: "unary";
    input: typeof GetDealSavedSearchListRequestSchema;
    output: typeof GetDealSavedSearchListResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetDealSavedSearch
   */
  getDealSavedSearch: {
    methodKind: "unary";
    input: typeof GetDealSavedSearchRequestSchema;
    output: typeof GetDealSavedSearchResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateDealSavedSearch
   */
  updateDealSavedSearch: {
    methodKind: "unary";
    input: typeof UpdateDealSavedSearchRequestSchema;
    output: typeof UpdateDealSavedSearchResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteDealSavedSearch
   */
  deleteDealSavedSearch: {
    methodKind: "unary";
    input: typeof DeleteDealSavedSearchRequestSchema;
    output: typeof DeleteDealSavedSearchResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.CreateCustomerMemo
   */
  createCustomerMemo: {
    methodKind: "unary";
    input: typeof CreateCustomerMemoRequestSchema;
    output: typeof CustomerMemoResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateCustomerMemo
   */
  updateCustomerMemo: {
    methodKind: "unary";
    input: typeof UpdateCustomerMemoRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteCustomerMemo
   */
  deleteCustomerMemo: {
    methodKind: "unary";
    input: typeof DeleteCustomerMemoRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetCustomerMemoList
   */
  getCustomerMemoList: {
    methodKind: "unary";
    input: typeof GetCustomerMemoListRequestSchema;
    output: typeof GetCustomerMemoListResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.TogglePinCustomerMemo
   */
  togglePinCustomerMemo: {
    methodKind: "unary";
    input: typeof TogglePinCustomerMemoRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 見積書を作成する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateQuotation
   */
  createQuotation: {
    methodKind: "unary";
    input: typeof CreateQuotationRequestSchema;
    output: typeof CreateQuotationResponseSchema;
  },
  /**
   * 見積書を更新する
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateQuotation
   */
  updateQuotation: {
    methodKind: "unary";
    input: typeof UpdateQuotationRequestSchema;
    output: typeof UpdateQuotationResponseSchema;
  },
  /**
   * 見積書一覧を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetQuotationList
   */
  getQuotationList: {
    methodKind: "unary";
    input: typeof GetQuotationListRequestSchema;
    output: typeof GetQuotationListResponseSchema;
  },
  /**
   * 見積書を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetQuotation
   */
  getQuotation: {
    methodKind: "unary";
    input: typeof GetQuotationRequestSchema;
    output: typeof GetQuotationResponseSchema;
  },
  /**
   * 見積書を削除する
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteQuotation
   */
  deleteQuotation: {
    methodKind: "unary";
    input: typeof DeleteQuotationRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 見積書番号を生成する
   *
   * @generated from rpc api_proto.v1.CompanyService.GenerateQuotationNumber
   */
  generateQuotationNumber: {
    methodKind: "unary";
    input: typeof GenerateQuotationNumberRequestSchema;
    output: typeof GenerateQuotationNumberResponseSchema;
  },
  /**
   * 請求書を作成する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateInvoice
   */
  createInvoice: {
    methodKind: "unary";
    input: typeof CreateInvoiceRequestSchema;
    output: typeof CreateInvoiceResponseSchema;
  },
  /**
   * 請求書番号を生成する
   *
   * @generated from rpc api_proto.v1.CompanyService.GenerateInvoiceNumber
   */
  generateInvoiceNumber: {
    methodKind: "unary";
    input: typeof GenerateInvoiceNumberRequestSchema;
    output: typeof GenerateInvoiceNumberResponseSchema;
  },
  /**
   * 請求書を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetInvoice
   */
  getInvoice: {
    methodKind: "unary";
    input: typeof GetInvoiceRequestSchema;
    output: typeof GetInvoiceResponseSchema;
  },
  /**
   * 請求書を更新する
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateInvoice
   */
  updateInvoice: {
    methodKind: "unary";
    input: typeof UpdateInvoiceRequestSchema;
    output: typeof UpdateInvoiceResponseSchema;
  },
  /**
   * 請求書一覧を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetInvoiceList
   */
  getInvoiceList: {
    methodKind: "unary";
    input: typeof GetInvoiceListRequestSchema;
    output: typeof GetInvoiceListResponseSchema;
  },
  /**
   * 請求書を削除する
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteInvoice
   */
  deleteInvoice: {
    methodKind: "unary";
    input: typeof DeleteInvoiceRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 既存の案件を見積書と連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.LinkDealToQuotation
   */
  linkDealToQuotation: {
    methodKind: "unary";
    input: typeof LinkDealToQuotationRequestSchema;
    output: typeof LinkDealToQuotationResponseSchema;
  },
  /**
   * 新しい案件を作成して見積書と連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAndLinkDealToQuotation
   */
  createAndLinkDealToQuotation: {
    methodKind: "unary";
    input: typeof CreateAndLinkDealToQuotationRequestSchema;
    output: typeof LinkDealToQuotationResponseSchema;
  },
  /**
   * 見積書から案件の連携を解除する
   *
   * @generated from rpc api_proto.v1.CompanyService.UnlinkDealFromQuotation
   */
  unlinkDealFromQuotation: {
    methodKind: "unary";
    input: typeof UnlinkDealFromQuotationRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 既存の案件を請求書と連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.LinkDealToInvoice
   */
  linkDealToInvoice: {
    methodKind: "unary";
    input: typeof LinkDealToInvoiceRequestSchema;
    output: typeof LinkDealToInvoiceResponseSchema;
  },
  /**
   * 新しい案件を作成して請求書と連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAndLinkDealToInvoice
   */
  createAndLinkDealToInvoice: {
    methodKind: "unary";
    input: typeof CreateAndLinkDealToInvoiceRequestSchema;
    output: typeof LinkDealToInvoiceResponseSchema;
  },
  /**
   * 請求書から案件の連携を解除する
   *
   * @generated from rpc api_proto.v1.CompanyService.UnlinkDealFromInvoice
   */
  unlinkDealFromInvoice: {
    methodKind: "unary";
    input: typeof UnlinkDealFromInvoiceRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 案件から見積書を作成して連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateQuotationFromDeal
   */
  createQuotationFromDeal: {
    methodKind: "unary";
    input: typeof CreateQuotationFromDealRequestSchema;
    output: typeof CreateQuotationFromDealResponseSchema;
  },
  /**
   * 案件に既存の見積書を連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.LinkQuotationToDeal
   */
  linkQuotationToDeal: {
    methodKind: "unary";
    input: typeof LinkQuotationToDealRequestSchema;
    output: typeof LinkQuotationToDealResponseSchema;
  },
  /**
   * 案件から請求書を作成して連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateInvoiceFromDeal
   */
  createInvoiceFromDeal: {
    methodKind: "unary";
    input: typeof CreateInvoiceFromDealRequestSchema;
    output: typeof CreateInvoiceFromDealResponseSchema;
  },
  /**
   * 案件に既存の請求書を連携する
   *
   * @generated from rpc api_proto.v1.CompanyService.LinkInvoiceToDeal
   */
  linkInvoiceToDeal: {
    methodKind: "unary";
    input: typeof LinkInvoiceToDealRequestSchema;
    output: typeof LinkInvoiceToDealResponseSchema;
  },
  /**
   * 工事内容選択肢を取得する（企業の工種に応じて順番を出し分け）
   *
   * @generated from rpc api_proto.v1.CompanyService.GetConstructionContentOptions
   */
  getConstructionContentOptions: {
    methodKind: "unary";
    input: typeof GetConstructionContentOptionsRequestSchema;
    output: typeof GetConstructionContentOptionsResponseSchema;
  },
  /**
   * 施工事例記事を生成する
   *
   * @generated from rpc api_proto.v1.CompanyService.GenerateCaseStudy
   */
  generateCaseStudy: {
    methodKind: "unary";
    input: typeof GenerateCaseStudyRequestSchema;
    output: typeof GenerateCaseStudyResponseSchema;
  },
  /**
   * 案件IDで最新の施工事例記事を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetCaseStudyArticlesByDealId
   */
  getCaseStudyArticlesByDealId: {
    methodKind: "unary";
    input: typeof GetCaseStudyArticlesByDealIdRequestSchema;
    output: typeof GetCaseStudyArticlesByDealIdResponseSchema;
  },
  /**
   * 施工事例：案件選択 Drawer 用の一覧
   *
   * @generated from rpc api_proto.v1.CompanyService.ListCaseStudyDeals
   */
  listCaseStudyDeals: {
    methodKind: "unary";
    input: typeof ListCaseStudyDealsRequestSchema;
    output: typeof ListCaseStudyDealsResponseSchema;
  },
  /**
   * 施工事例：記事ステータス更新
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateCaseStudyArticleStatus
   */
  updateCaseStudyArticleStatus: {
    methodKind: "unary";
    input: typeof UpdateCaseStudyArticleStatusRequestSchema;
    output: typeof UpdateCaseStudyArticleStatusResponseSchema;
  },
  /**
   * 施工事例：施主許諾更新
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateCaseStudyOwnerConsent
   */
  updateCaseStudyOwnerConsent: {
    methodKind: "unary";
    input: typeof UpdateCaseStudyOwnerConsentRequestSchema;
    output: typeof UpdateCaseStudyOwnerConsentResponseSchema;
  },
  /**
   * 施工事例：案件に紐づく選択写真を取得する（alt サジェスト・公開URL付き）
   *
   * @generated from rpc api_proto.v1.CompanyService.GetCaseStudyImages
   */
  getCaseStudyImages: {
    methodKind: "unary";
    input: typeof GetCaseStudyImagesRequestSchema;
    output: typeof GetCaseStudyImagesResponseSchema;
  },
  /**
   * 施工事例：案件に紐づく選択写真を保存する（案件単位の全置換）
   *
   * @generated from rpc api_proto.v1.CompanyService.SaveCaseStudyImages
   */
  saveCaseStudyImages: {
    methodKind: "unary";
    input: typeof SaveCaseStudyImagesRequestSchema;
    output: typeof SaveCaseStudyImagesResponseSchema;
  },
  /**
   * 施工事例：写真の選択候補を取得する。中身は GetDealImages と同じ画像プール
   * （案件ファイルの画像 + AIカラーシミュレーション結果画像）で、現地調査報告書の内容は含まない。
   * GetDealImages は報告書の権限を要求するため、施工事例の権限（free.case_study）と
   * 対象案件の閲覧で判定する専用の入口を分けている
   *
   * @generated from rpc api_proto.v1.CompanyService.GetCaseStudyDealImages
   */
  getCaseStudyDealImages: {
    methodKind: "unary";
    input: typeof GetDealImagesRequestSchema;
    output: typeof GetDealImagesResponseSchema;
  },
  /**
   * 施工事例：写真のその場アップロード（署名付き URL の発行）。保存先は案件ファイル。
   * CreateDealFileUploadUrl は案件ファイルの full を要求するため、施工事例の権限で通る入口を分けている
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateCaseStudyImageUploadUrl
   */
  createCaseStudyImageUploadUrl: {
    methodKind: "unary";
    input: typeof CreateDealFileUploadUrlRequestSchema;
    output: typeof CreateDealFileUploadUrlResponseSchema;
  },
  /**
   * 施工事例：写真のその場アップロードの確定（案件ファイルとして登録）。事情は上と同じ
   *
   * @generated from rpc api_proto.v1.CompanyService.FinalizeCaseStudyImageUpload
   */
  finalizeCaseStudyImageUpload: {
    methodKind: "unary";
    input: typeof FinalizeDealFileUploadRequestSchema;
    output: typeof FinalizeDealFileUploadResponseSchema;
  },
  /**
   * 施工事例記事：選択済み写真の回転。事情は CreateCaseStudyImageUploadUrl と同じ (issue #2599)
   *
   * @generated from rpc api_proto.v1.CompanyService.RotateCaseStudyImage
   */
  rotateCaseStudyImage: {
    methodKind: "unary";
    input: typeof RotateDealFileImageRequestSchema;
    output: typeof RotateDealFileImageResponseSchema;
  },
  /**
   * 現場調査報告書を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetSurveyReport
   */
  getSurveyReport: {
    methodKind: "unary";
    input: typeof GetSurveyReportRequestSchema;
    output: typeof GetSurveyReportResponseSchema;
  },
  /**
   * 企業横断の現地調査報告書一覧を取得する（決定 72。AIツール > 現地調査報告書のトップレベル一覧）
   *
   * @generated from rpc api_proto.v1.CompanyService.ListCompanySurveyReports
   */
  listCompanySurveyReports: {
    methodKind: "unary";
    input: typeof ListCompanySurveyReportsRequestSchema;
    output: typeof ListCompanySurveyReportsResponseSchema;
  },
  /**
   * 現場調査報告書を保存する
   *
   * @generated from rpc api_proto.v1.CompanyService.SaveSurveyReport
   */
  saveSurveyReport: {
    methodKind: "unary";
    input: typeof SaveSurveyReportRequestSchema;
    output: typeof SaveSurveyReportResponseSchema;
  },
  /**
   * 現場調査報告書を削除する
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteSurveyReport
   */
  deleteSurveyReport: {
    methodKind: "unary";
    input: typeof DeleteSurveyReportRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 案件画像一覧を取得する（画像系ファイルのみ）
   *
   * @generated from rpc api_proto.v1.CompanyService.GetDealImages
   */
  getDealImages: {
    methodKind: "unary";
    input: typeof GetDealImagesRequestSchema;
    output: typeof GetDealImagesResponseSchema;
  },
  /**
   * AI執筆支援（現場調査報告書用）
   *
   * @generated from rpc api_proto.v1.CompanyService.GenerateSurveyText
   */
  generateSurveyText: {
    methodKind: "unary";
    input: typeof GenerateSurveyTextRequestSchema;
    output: typeof GenerateSurveyTextResponseSchema;
  },
  /**
   * 現場調査報告書：写真のその場アップロード（同期。保存先は案件ファイル）。中身は UploadDealFiles と同じ。
   * UploadDealFiles は案件ファイルの full を要求するため、報告書の権限（ai.survey_report）と
   * 対象案件の閲覧で判定する専用の入口を分けている
   *
   * @generated from rpc api_proto.v1.CompanyService.UploadSurveyReportImages
   */
  uploadSurveyReportImages: {
    methodKind: "unary";
    input: typeof UploadDealFilesRequestSchema;
    output: typeof UploadDealFilesResponseSchema;
  },
  /**
   * 現場調査報告書：選択済み写真の回転。中身は RotateDealFileImage と同じ。
   * RotateDealFileImage は案件ファイルの full を要求するため、報告書の権限（ai.survey_report）と
   * 案件の閲覧権限で通る入口を分けている (issue #2599)。
   * リクエストは file_id だけで案件を指さないので、テナント分離は company_id の絞り込みで担保する。
   *
   * @generated from rpc api_proto.v1.CompanyService.RotateSurveyReportImage
   */
  rotateSurveyReportImage: {
    methodKind: "unary";
    input: typeof RotateDealFileImageRequestSchema;
    output: typeof RotateDealFileImageResponseSchema;
  },
  /**
   * AIカラー: 企業の使用可能な色一覧を取得（カラーシミュレーション表示用）
   *
   * @generated from rpc api_proto.v1.CompanyService.ListCompanyColors
   */
  listCompanyColors: {
    methodKind: "unary";
    input: typeof ListCompanyColorsRequestSchema;
    output: typeof ListCompanyColorsResponseSchema;
  },
  /**
   * AIカラー: 企業の使用可能な素材一覧を取得（素材変更シミュレーション表示用）
   *
   * @generated from rpc api_proto.v1.CompanyService.ListCompanyMaterials
   */
  listCompanyMaterials: {
    methodKind: "unary";
    input: typeof ListCompanyMaterialsRequestSchema;
    output: typeof ListCompanyMaterialsResponseSchema;
  },
  /**
   * 企業プリセット一覧を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.ListAiColorPresets
   */
  listAiColorPresets: {
    methodKind: "unary";
    input: typeof ListAiColorPresetsRequestSchema;
    output: typeof ListAiColorPresetsResponseSchema;
  },
  /**
   * 企業プリセットを作成する
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAiColorPreset
   */
  createAiColorPreset: {
    methodKind: "unary";
    input: typeof CreateAiColorPresetRequestSchema;
    output: typeof CreateAiColorPresetResponseSchema;
  },
  /**
   * 企業プリセットを更新する（colors は順序付き全置換）
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateAiColorPreset
   */
  updateAiColorPreset: {
    methodKind: "unary";
    input: typeof UpdateAiColorPresetRequestSchema;
    output: typeof UpdateAiColorPresetResponseSchema;
  },
  /**
   * 企業プリセットを削除する（デフォルト指定中は FailedPrecondition）
   *
   * @generated from rpc api_proto.v1.CompanyService.DeleteAiColorPreset
   */
  deleteAiColorPreset: {
    methodKind: "unary";
    input: typeof DeleteAiColorPresetRequestSchema;
    output: typeof DeleteAiColorPresetResponseSchema;
  },
  /**
   * ベースエリアのデフォルトプリセット設定を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetBaseAreaPresetDefaults
   */
  getBaseAreaPresetDefaults: {
    methodKind: "unary";
    input: typeof GetBaseAreaPresetDefaultsRequestSchema;
    output: typeof GetBaseAreaPresetDefaultsResponseSchema;
  },
  /**
   * ベースエリアのデフォルトプリセットをエリア単位で upsert する
   *
   * @generated from rpc api_proto.v1.CompanyService.SetBaseAreaPresetDefault
   */
  setBaseAreaPresetDefault: {
    methodKind: "unary";
    input: typeof SetBaseAreaPresetDefaultRequestSchema;
    output: typeof SetBaseAreaPresetDefaultResponseSchema;
  },
  /**
   * 新着色（過去7日以内に登録された色）の件数を取得する（通知表示用）
   *
   * @generated from rpc api_proto.v1.CompanyService.CountNewColors
   */
  countNewColors: {
    methodKind: "unary";
    input: typeof CountNewColorsRequestSchema;
    output: typeof CountNewColorsResponseSchema;
  },
  /**
   * 積算プロジェクト
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAreaEstimationProject
   */
  createAreaEstimationProject: {
    methodKind: "unary";
    input: typeof CreateAreaEstimationProjectRequestSchema;
    output: typeof CreateAreaEstimationProjectResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.ListAreaEstimationProjects
   */
  listAreaEstimationProjects: {
    methodKind: "unary";
    input: typeof ListAreaEstimationProjectsRequestSchema;
    output: typeof ListAreaEstimationProjectsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetAreaEstimationProject
   */
  getAreaEstimationProject: {
    methodKind: "unary";
    input: typeof GetAreaEstimationProjectRequestSchema;
    output: typeof GetAreaEstimationProjectResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateAreaEstimationProject
   */
  updateAreaEstimationProject: {
    methodKind: "unary";
    input: typeof UpdateAreaEstimationProjectRequestSchema;
    output: typeof UpdateAreaEstimationProjectResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteAreaEstimationProject
   */
  deleteAreaEstimationProject: {
    methodKind: "unary";
    input: typeof DeleteAreaEstimationProjectRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 図面 (PDF アップロード → 解析)
   *
   * @generated from rpc api_proto.v1.CompanyService.CreateAreaEstimationDrawing
   */
  createAreaEstimationDrawing: {
    methodKind: "unary";
    input: typeof CreateAreaEstimationDrawingRequestSchema;
    output: typeof CreateAreaEstimationDrawingResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetAreaEstimationDrawing
   */
  getAreaEstimationDrawing: {
    methodKind: "unary";
    input: typeof GetAreaEstimationDrawingRequestSchema;
    output: typeof GetAreaEstimationDrawingResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.GetAreaEstimationDrawingAnalysisStatus
   */
  getAreaEstimationDrawingAnalysisStatus: {
    methodKind: "unary";
    input: typeof GetAreaEstimationDrawingAnalysisStatusRequestSchema;
    output: typeof GetAreaEstimationDrawingAnalysisStatusResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.ReanalyzeAreaEstimationDrawing
   */
  reanalyzeAreaEstimationDrawing: {
    methodKind: "unary";
    input: typeof ReanalyzeAreaEstimationDrawingRequestSchema;
    output: typeof ReanalyzeAreaEstimationDrawingResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.DeleteAreaEstimationDrawing
   */
  deleteAreaEstimationDrawing: {
    methodKind: "unary";
    input: typeof DeleteAreaEstimationDrawingRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.UpdateAreaEstimationDrawingScale
   */
  updateAreaEstimationDrawingScale: {
    methodKind: "unary";
    input: typeof UpdateAreaEstimationDrawingScaleRequestSchema;
    output: typeof UpdateAreaEstimationDrawingScaleResponseSchema;
  },
  /**
   * ジオメトリ編集・面積計算
   *
   * @generated from rpc api_proto.v1.CompanyService.SaveAreaEstimationDrawingGeometry
   */
  saveAreaEstimationDrawingGeometry: {
    methodKind: "unary";
    input: typeof SaveAreaEstimationDrawingGeometryRequestSchema;
    output: typeof SaveAreaEstimationDrawingGeometryResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.CalculateAreaEstimationDrawingArea
   */
  calculateAreaEstimationDrawingArea: {
    methodKind: "unary";
    input: typeof CalculateAreaEstimationDrawingAreaRequestSchema;
    output: typeof CalculateAreaEstimationDrawingAreaResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.CompanyService.ListAreaEstimationDrawingRevisions
   */
  listAreaEstimationDrawingRevisions: {
    methodKind: "unary";
    input: typeof ListAreaEstimationDrawingRevisionsRequestSchema;
    output: typeof ListAreaEstimationDrawingRevisionsResponseSchema;
  },
  /**
   * SEO 記事を生成する
   *
   * @generated from rpc api_proto.v1.CompanyService.GenerateSeoArticle
   */
  generateSeoArticle: {
    methodKind: "unary";
    input: typeof GenerateSeoArticleRequestSchema;
    output: typeof GenerateSeoArticleResponseSchema;
  },
  /**
   * 生成済み SEO 記事を追加指示で修正する
   *
   * @generated from rpc api_proto.v1.CompanyService.ReviseSeoArticle
   */
  reviseSeoArticle: {
    methodKind: "unary";
    input: typeof ReviseSeoArticleRequestSchema;
    output: typeof GenerateSeoArticleResponseSchema;
  },
  /**
   * SEO 記事生成履歴の一覧を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.ListSeoGenerationHistory
   */
  listSeoGenerationHistory: {
    methodKind: "unary";
    input: typeof ListSeoGenerationHistoryRequestSchema;
    output: typeof ListSeoGenerationHistoryResponseSchema;
  },
  /**
   * 生成履歴から保存済み記事を取得する（編集再開用）
   *
   * @generated from rpc api_proto.v1.CompanyService.GetSeoGenerationArticle
   */
  getSeoGenerationArticle: {
    methodKind: "unary";
    input: typeof GetSeoGenerationArticleRequestSchema;
    output: typeof GetSeoGenerationArticleResponseSchema;
  },
  /**
   * 質問項目カスタマイズ設定を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetReviewQuestionConfig
   */
  getReviewQuestionConfig: {
    methodKind: "unary";
    input: typeof GetReviewQuestionConfigRequestSchema;
    output: typeof GetReviewQuestionConfigResponseSchema;
  },
  /**
   * 質問項目カスタマイズ設定を更新する
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateReviewQuestionConfig
   */
  updateReviewQuestionConfig: {
    methodKind: "unary";
    input: typeof UpdateReviewQuestionConfigRequestSchema;
    output: typeof UpdateReviewQuestionConfigResponseSchema;
  },
  /**
   * 口コミ機能設定（slug / Place ID / 有効化 / URL）を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetReviewSettings
   */
  getReviewSettings: {
    methodKind: "unary";
    input: typeof GetReviewSettingsRequestSchema;
    output: typeof GetReviewSettingsResponseSchema;
  },
  /**
   * Google Maps Place ID を更新する（slug / review_enabled は admin 経由）
   *
   * @generated from rpc api_proto.v1.CompanyService.UpdateReviewSettings
   */
  updateReviewSettings: {
    methodKind: "unary";
    input: typeof UpdateReviewSettingsRequestSchema;
    output: typeof UpdateReviewSettingsResponseSchema;
  },
  /**
   * 投稿された口コミ案の履歴一覧を取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.ListReviewSubmissions
   */
  listReviewSubmissions: {
    methodKind: "unary";
    input: typeof ListReviewSubmissionsRequestSchema;
    output: typeof ListReviewSubmissionsResponseSchema;
  },
  /**
   * 自社の契約・クレジット残高・体験クレジット・アカウント数をまとめて取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.GetOwnPlanStatus
   */
  getOwnPlanStatus: {
    methodKind: "unary";
    input: typeof GetOwnPlanStatusRequestSchema;
    output: typeof GetOwnPlanStatusResponseSchema;
  },
  /**
   * 自社のクレジット利用履歴（付与 / 確定消費 / 失効）をページングで取得する
   *
   * @generated from rpc api_proto.v1.CompanyService.ListOwnCreditLedgerEntries
   */
  listOwnCreditLedgerEntries: {
    methodKind: "unary";
    input: typeof ListOwnCreditLedgerEntriesRequestSchema;
    output: typeof ListOwnCreditLedgerEntriesResponseSchema;
  },
  /**
   * プランの申し込み・変更・クレジット追加希望を営業へ通知する（DBには保存しない）
   *
   * @generated from rpc api_proto.v1.CompanyService.SubmitPlanInquiry
   */
  submitPlanInquiry: {
    methodKind: "unary";
    input: typeof SubmitPlanInquiryRequestSchema;
    output: typeof SubmitPlanInquiryResponseSchema;
  },
  /**
   * プラン・クレジットで止められた操作（ロック表示のクリック・ロックされた画面の表示）を記録する（効果測定用）
   *
   * @generated from rpc api_proto.v1.CompanyService.RecordFeatureBlock
   */
  recordFeatureBlock: {
    methodKind: "unary";
    input: typeof RecordFeatureBlockRequestSchema;
    output: typeof RecordFeatureBlockResponseSchema;
  },
  /**
   * いま答えるべきNPSの設問を返す（期間内・未回答のときだけ設定）
   *
   * @generated from rpc api_proto.v1.CompanyService.GetPendingNpsSurvey
   */
  getPendingNpsSurvey: {
    methodKind: "unary";
    input: typeof GetPendingNpsSurveyRequestSchema;
    output: typeof GetPendingNpsSurveyResponseSchema;
  },
  /**
   * NPSの回答を保存する（設問×スタッフで一意。重複は成功として扱う）
   *
   * @generated from rpc api_proto.v1.CompanyService.SubmitNpsResponse
   */
  submitNpsResponse: {
    methodKind: "unary";
    input: typeof SubmitNpsResponseRequestSchema;
    output: typeof SubmitNpsResponseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_proto_v1_company_service, 0);

